// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verificacao-andaimes-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: #333;
}

.va-content-wrapper {
    max-width: 800px;
    margin: 0 auto;
    width: 100%;
}

.va-header {
    text-align: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #0056b3;
}

.va-header h2 {
    margin: 0 0 5px 0;
    color: #1a1a1a;
    font-size: 1.5rem;
}

.va-header p {
    margin: 0;
    color: #666;
    font-size: 0.95rem;
}

.va-message {
    padding: 12px 15px;
    margin-bottom: 20px;
    border-radius: 6px;
    font-weight: 500;
}

.va-message.success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.va-message.error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.va-form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.va-form-group label {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 0.95rem;
    color: #444;
}

.va-form-group select,
.va-form-group input[type="date"],
.va-form-group textarea {
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    font-family: inherit;
    background-color: #fff;
    transition: border-color 0.2s;
}

.va-form-group select:focus,
.va-form-group input[type="date"]:focus,
.va-form-group textarea:focus {
    outline: none;
    border-color: #0056b3;
    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);
}

.va-checklist-section h3 {
    margin-top: 30px;
    margin-bottom: 15px;
    color: #0056b3;
    font-size: 1.25rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
}

.va-section-block {
    margin-bottom: 30px;
    background-color: #fff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.va-section-title {
    background-color: #f8f9fa;
    margin: 0;
    padding: 12px 15px;
    border-bottom: 1px solid #e1e4e8;
    font-size: 1.05rem;
    color: #2c3e50;
}

.va-table-wrapper {
    overflow-x: auto;
}

.va-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 300px;
    /* Allow shrinking on mobile */
}

.va-table th,
.va-table td {
    padding: 6px 4px;
    /* Reduced padding for mobile */
    border-bottom: 1px solid #eee;
    vertical-align: middle;
    font-size: 0.8rem;
    /* Smaller text avoids cutting */
}

.va-table th {
    background-color: #f1f5f9;
    color: #475569;
    font-weight: 600;
    text-align: left;
}

.td-req,
.th-req {
    width: 48%;
    /* Adjust to fit everything */
}

.td-opt,
.th-opt {
    width: 8%;
    text-align: center;
}

.td-obs,
.th-obs {
    width: 28%;
}

.req-id {
    display: inline-block;
    width: 30px;
    font-weight: bold;
    color: #64748b;
}

.req-text {
    display: inline-block;
    width: calc(100% - 35px);
    vertical-align: top;
    line-height: 1.4;
}

.td-opt input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #0056b3;
    cursor: pointer;
}

.td-obs input[type="text"] {
    width: 100%;
    padding: 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.85rem;
}

.va-result-group {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.va-radio-row {
    display: flex;
    flex-wrap: wrap;
    /* Prevent cutting on small phones */
    gap: 15px;
}

.va-radio-row label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    cursor: pointer;
}

.va-radio-row input[type="radio"] {
    width: 16px;
    height: 16px;
}

.va-photos-section {
    margin: 30px 0;
    padding: 20px;
    background-color: #f8fafe;
    border: 1px dashed #bcdcff;
    border-radius: 8px;
}

.photo-upload-wrapper {
    margin-bottom: 20px;
}

.photo-upload-wrapper input[type="file"] {
    display: none;
}

.upload-btn {
    display: inline-block;
    background-color: #e2e8f0;
    color: #334155;
    padding: 10px 20px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
    border: 1px solid #cbd5e1;
}

.upload-btn:hover {
    background-color: #cbd5e1;
}

.upload-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
}

.photo-preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 15px;
}

.photo-thumbnail {
    position: relative;
    padding-top: 100%;
    /* 1:1 Aspect Ratio */
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.photo-thumbnail img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.remove-photo-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: rgba(220, 53, 69, 0.9);
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
}

.remove-photo-btn:hover {
    background-color: #c82333;
}

.va-actions {
    margin-top: 30px;
    text-align: right;
}

.va-submit-btn {
    background-color: #0056b3;
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1.1rem;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
    width: 100%;
}

.va-submit-btn:hover:not(:disabled) {
    background-color: #004494;
}

.va-submit-btn:active:not(:disabled) {
    transform: scale(0.98);
}

.va-submit-btn:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
}

.va-success-actions {
    padding: 30px;
    background-color: #f8f9fa;
    border-radius: 8px;
    text-align: center;
    border: 1px solid #e9ecef;
}

.success-text {
    font-size: 1.2rem;
    color: #155724;
    font-weight: 600;
    margin-bottom: 25px;
}

.btn-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 25px;
}

.va-action-btn {
    display: inline-block;
    padding: 12px 20px;
    border-radius: 6px;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
    border: none;
    font-size: 1rem;
    transition: opacity 0.2s;
}

.va-action-btn:hover {
    opacity: 0.9;
}

.download-btn {
    background-color: #dc3545;
    color: white;
}

.share-btn {
    background-color: #25D366;
    /* WhatsApp style green */
    color: white;
}

.secondary-btn {
    background-color: #e2e8f0;
    color: #334155;
    width: 100%;
}

/* Mobile Adjustments */
@media (min-width: 768px) {
    .va-submit-btn {
        width: auto;
    }

    .btn-group {
        flex-direction: row;
        justify-content: center;
    }

    .secondary-btn {
        width: auto;
    }

    .va-table-wrapper {
        overflow-x: visible;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/VerificacaoAndaime.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,yGAAyG;IACzG,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;;IAEI,gBAAgB;IAChB,+BAA+B;IAC/B,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iDAAiD;IACjD,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".verificacao-andaimes-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    color: #333;\r\n}\r\n\r\n.va-content-wrapper {\r\n    max-width: 800px;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n}\r\n\r\n.va-header {\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 2px solid #0056b3;\r\n}\r\n\r\n.va-header h2 {\r\n    margin: 0 0 5px 0;\r\n    color: #1a1a1a;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.va-header p {\r\n    margin: 0;\r\n    color: #666;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.va-message {\r\n    padding: 12px 15px;\r\n    margin-bottom: 20px;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n}\r\n\r\n.va-message.success {\r\n    background-color: #d4edda;\r\n    color: #155724;\r\n    border: 1px solid #c3e6cb;\r\n}\r\n\r\n.va-message.error {\r\n    background-color: #f8d7da;\r\n    color: #721c24;\r\n    border: 1px solid #f5c6cb;\r\n}\r\n\r\n.va-form-group {\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.va-form-group label {\r\n    font-weight: 600;\r\n    margin-bottom: 8px;\r\n    font-size: 0.95rem;\r\n    color: #444;\r\n}\r\n\r\n.va-form-group select,\r\n.va-form-group input[type=\"date\"],\r\n.va-form-group textarea {\r\n    padding: 10px 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n    font-size: 1rem;\r\n    font-family: inherit;\r\n    background-color: #fff;\r\n    transition: border-color 0.2s;\r\n}\r\n\r\n.va-form-group select:focus,\r\n.va-form-group input[type=\"date\"]:focus,\r\n.va-form-group textarea:focus {\r\n    outline: none;\r\n    border-color: #0056b3;\r\n    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);\r\n}\r\n\r\n.va-checklist-section h3 {\r\n    margin-top: 30px;\r\n    margin-bottom: 15px;\r\n    color: #0056b3;\r\n    font-size: 1.25rem;\r\n    border-bottom: 1px solid #eee;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.va-section-block {\r\n    margin-bottom: 30px;\r\n    background-color: #fff;\r\n    border: 1px solid #e1e4e8;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.va-section-title {\r\n    background-color: #f8f9fa;\r\n    margin: 0;\r\n    padding: 12px 15px;\r\n    border-bottom: 1px solid #e1e4e8;\r\n    font-size: 1.05rem;\r\n    color: #2c3e50;\r\n}\r\n\r\n.va-table-wrapper {\r\n    overflow-x: auto;\r\n}\r\n\r\n.va-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    min-width: 300px;\r\n    /* Allow shrinking on mobile */\r\n}\r\n\r\n.va-table th,\r\n.va-table td {\r\n    padding: 6px 4px;\r\n    /* Reduced padding for mobile */\r\n    border-bottom: 1px solid #eee;\r\n    vertical-align: middle;\r\n    font-size: 0.8rem;\r\n    /* Smaller text avoids cutting */\r\n}\r\n\r\n.va-table th {\r\n    background-color: #f1f5f9;\r\n    color: #475569;\r\n    font-weight: 600;\r\n    text-align: left;\r\n}\r\n\r\n.td-req,\r\n.th-req {\r\n    width: 48%;\r\n    /* Adjust to fit everything */\r\n}\r\n\r\n.td-opt,\r\n.th-opt {\r\n    width: 8%;\r\n    text-align: center;\r\n}\r\n\r\n.td-obs,\r\n.th-obs {\r\n    width: 28%;\r\n}\r\n\r\n.req-id {\r\n    display: inline-block;\r\n    width: 30px;\r\n    font-weight: bold;\r\n    color: #64748b;\r\n}\r\n\r\n.req-text {\r\n    display: inline-block;\r\n    width: calc(100% - 35px);\r\n    vertical-align: top;\r\n    line-height: 1.4;\r\n}\r\n\r\n.td-opt input[type=\"radio\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n    accent-color: #0056b3;\r\n    cursor: pointer;\r\n}\r\n\r\n.td-obs input[type=\"text\"] {\r\n    width: 100%;\r\n    padding: 6px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.va-result-group {\r\n    background-color: #f8f9fa;\r\n    padding: 15px;\r\n    border-radius: 6px;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.va-radio-row {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    /* Prevent cutting on small phones */\r\n    gap: 15px;\r\n}\r\n\r\n.va-radio-row label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n}\r\n\r\n.va-radio-row input[type=\"radio\"] {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n.va-photos-section {\r\n    margin: 30px 0;\r\n    padding: 20px;\r\n    background-color: #f8fafe;\r\n    border: 1px dashed #bcdcff;\r\n    border-radius: 8px;\r\n}\r\n\r\n.photo-upload-wrapper {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.photo-upload-wrapper input[type=\"file\"] {\r\n    display: none;\r\n}\r\n\r\n.upload-btn {\r\n    display: inline-block;\r\n    background-color: #e2e8f0;\r\n    color: #334155;\r\n    padding: 10px 20px;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s;\r\n    border: 1px solid #cbd5e1;\r\n}\r\n\r\n.upload-btn:hover {\r\n    background-color: #cbd5e1;\r\n}\r\n\r\n.upload-btn.disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\n.photo-preview-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\r\n    gap: 15px;\r\n}\r\n\r\n.photo-thumbnail {\r\n    position: relative;\r\n    padding-top: 100%;\r\n    /* 1:1 Aspect Ratio */\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.photo-thumbnail img {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n}\r\n\r\n.remove-photo-btn {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n    background-color: rgba(220, 53, 69, 0.9);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.remove-photo-btn:hover {\r\n    background-color: #c82333;\r\n}\r\n\r\n.va-actions {\r\n    margin-top: 30px;\r\n    text-align: right;\r\n}\r\n\r\n.va-submit-btn {\r\n    background-color: #0056b3;\r\n    color: white;\r\n    border: none;\r\n    padding: 12px 30px;\r\n    font-size: 1.1rem;\r\n    font-weight: 600;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s, transform 0.1s;\r\n    width: 100%;\r\n}\r\n\r\n.va-submit-btn:hover:not(:disabled) {\r\n    background-color: #004494;\r\n}\r\n\r\n.va-submit-btn:active:not(:disabled) {\r\n    transform: scale(0.98);\r\n}\r\n\r\n.va-submit-btn:disabled {\r\n    background-color: #94a3b8;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.va-success-actions {\r\n    padding: 30px;\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    border: 1px solid #e9ecef;\r\n}\r\n\r\n.success-text {\r\n    font-size: 1.2rem;\r\n    color: #155724;\r\n    font-weight: 600;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.btn-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.va-action-btn {\r\n    display: inline-block;\r\n    padding: 12px 20px;\r\n    border-radius: 6px;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    border: none;\r\n    font-size: 1rem;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n.va-action-btn:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n.download-btn {\r\n    background-color: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.share-btn {\r\n    background-color: #25D366;\r\n    /* WhatsApp style green */\r\n    color: white;\r\n}\r\n\r\n.secondary-btn {\r\n    background-color: #e2e8f0;\r\n    color: #334155;\r\n    width: 100%;\r\n}\r\n\r\n/* Mobile Adjustments */\r\n@media (min-width: 768px) {\r\n    .va-submit-btn {\r\n        width: auto;\r\n    }\r\n\r\n    .btn-group {\r\n        flex-direction: row;\r\n        justify-content: center;\r\n    }\r\n\r\n    .secondary-btn {\r\n        width: auto;\r\n    }\r\n\r\n    .va-table-wrapper {\r\n        overflow-x: visible;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
